

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { AwardOfContractComponent } from '../award-of-contract/award-of-contract.component';
import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
import { PreliminaryDesignComponent } from '../preliminary-design/preliminary-design.component';
import { CriticalDesignComponent } from '../critical-design/critical-design.component';
import { IdexUtrrComponent } from '../idex-utrr/idex-utrr.component';
import { ProductionSupplyComponent } from '../production-supply/production-supply.component';
import { TotComponent } from '../tot/tot.component';
import { PrototypeDeliveryComponent } from '../prototype-delivery/prototype-delivery.component';
import { PreparationOfPsqrFrommPddComponent } from '../preparation-of-psqr-fromm-pdd/preparation-of-psqr-fromm-pdd.component';
import { SsctComponent } from '../ssct/ssct.component';
import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
import { AONComponent } from '../stape-component/aon/aon.component';
import { ConstituteContractNegotiationCommitteeComponent } from '../constitute-contract-negotiation-committee/constitute-contract-negotiation-committee.component';
import { BanchmarkComponent } from '../stape-component/banchmark/banchmark.component';
import { IdexComponent } from '../idex/idex.component';
import { PreliminaryDiscussionComponent } from '../preliminary-discussion/preliminary-discussion.component';
import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
import { ConcurrenceRfiComponent } from '../concurrence-rfi/concurrence-rfi.component';
import { DrdoAipComponent } from '../drdo-aip/drdo-aip.component';
import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
import { FirmResponseEvaluationComponent } from '../firm-response-evaluation/firm-response-evaluation.component';
import { CommercialEvaluationComponent } from '../stape-component/financial-evaluation/commercial-evaluation.component';
import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';
import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { Table } from 'primeng/table';
import { BulkProductionComponent } from '../bulk-production/bulk-production.component';
import { IdexPrototypeComponent } from '../idex-prototype/idex-prototype.component';
import { IdexRfpSocComponent } from '../idex-rfp-soc/idex-rfp-soc.component';
import { NominateDirectorateComponent } from '../nominate-directorate/nominate-directorate.component';
import { ProjectClosureComponent } from '../project-closure/project-closure.component';
import { AIPComponent } from '../stape-component/aip/aip.component';
import { EOIComponent } from '../stape-component/eoi/eoi.component';
import { FinalOfferComponent } from '../stape-component/final-offer/final-offer.component';
import { FreezeSOTRComponent } from '../stape-component/freeze-sotr/freeze-sotr.component';
import { InitiationOfProposalComponent } from '../stape-component/initiation-of-proposal/initiation-of-proposal.component';
import { NeedGenrationComponent } from '../stape-component/need-genration/need-genration.component';
import { PreBidComponent } from '../stape-component/pre-bid/pre-bid.component';
import { PreRfpMeetingComponent } from '../stape-component/pre-rfp-meeting/pre-rfp-meeting.component';
import { SanctionOrderComponent } from '../stape-component/sanction-order/sanction-order.component';
import { SotrComponent } from '../stape-component/sotr/sotr.component';
import { UploadDrawingsComponent } from '../upload-drawings/upload-drawings.component';
import { UploadFatsComponent } from '../upload-fats/upload-fats.component';
import { UploadQapAtpComponent } from '../upload-qap-atp/upload-qap-atp.component';
import { UserCertificateComponent } from '../user-certificate/user-certificate.component';
import { UploadHatSatComponent } from '../stape-component/upload-hat-sat/upload-hat-sat.component';
import { RevenueBidComponent } from '../revenue-bid/revenue-bid.component';
import { SotrRfpComplienceMatrixComponent } from '../sotr-rfp-complience-matrix/sotr-rfp-complience-matrix.component'
import { FirmCapacityAssessmentComponent } from '../stape-component/firm-capacity-assessment/firm-capacity-assessment.component';


@Component({
  selector: 'app-transaction',
  standalone: false,
  templateUrl: './transaction.component.html',
  styleUrl: './transaction.component.scss'
})
export class TransactionComponent implements OnInit {
  @ViewChild(NeedGenrationComponent) needGen!: NeedGenrationComponent;
  @ViewChild(SotrComponent) sotr!: SotrComponent;
  @ViewChild(InitiationOfProposalComponent) initiationOfProposal!: InitiationOfProposalComponent;
  @ViewChild(FreezeSOTRComponent) freezeSOTR!: FreezeSOTRComponent;
  @ViewChild(AIPComponent) aip!: AIPComponent;
  @ViewChild(AONComponent) aon!: AONComponent;
  @ViewChild(EOIComponent) eoi!: EOIComponent;
  @ViewChild(IdexRfpSocComponent) idexRfpSoc!: IdexRfpSocComponent;
  @ViewChild(ConstituteCommitteeComponent) constituteCommittee!: ConstituteCommitteeComponent;
  @ViewChild(PreRfpMeetingComponent) preRfpMeeting!: PreRfpMeetingComponent;
  @ViewChild(IdexCommercialRfpComponent) idexCommercialRfp!: IdexCommercialRfpComponent;
  @ViewChild(PreBidComponent) preBid!: PreBidComponent;
  @ViewChild(BanchmarkComponent) banchmark!: BanchmarkComponent;
  @ViewChild(CommercialEvaluationComponent) commercialEvaluation!: CommercialEvaluationComponent;
  @ViewChild(FinalOfferComponent) finalOffer!: FinalOfferComponent;
  @ViewChild(SanctionOrderComponent) sanctionOrder!: SanctionOrderComponent;
  @ViewChild(NominateDirectorateComponent) nominateDirectorate!: NominateDirectorateComponent;
  @ViewChild(UploadDrawingsComponent) uploadDrawings!: UploadDrawingsComponent;
  @ViewChild(UploadQapAtpComponent) uploadQapAtp!: UploadQapAtpComponent;
  @ViewChild(UploadFatsComponent) uploadFats!: UploadFatsComponent;
  @ViewChild(IdexPrototypeComponent) idexPrototype!: IdexPrototypeComponent;
  @ViewChild(IdexUtrrComponent) idexUtrr!: IdexUtrrComponent;
  @ViewChild(UserCertificateComponent) userCertificate!: UserCertificateComponent;
  @ViewChild(BulkProductionComponent) bulkProduction!: BulkProductionComponent;
  @ViewChild(ProjectClosureComponent) projectClosure!: ProjectClosureComponent;
  @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
  @ViewChild(UploadHatSatComponent) uploadHatSatComponent!: UploadHatSatComponent;
  @ViewChild(RevenueBidComponent) revenueBidComponent!: RevenueBidComponent;
  @ViewChild(SotrRfpComplienceMatrixComponent) sotrRfpComplienceMatrix!: SotrRfpComplienceMatrixComponent;
  @ViewChild(FirmCapacityAssessmentComponent) firmCapacityAssessment!: FirmCapacityAssessmentComponent;

  @ViewChild('dt') documentTable!: Table;

  role_id = sessionStorage.getItem('user_role_id');

  baseUrl = environment.APIUrl;
  masterData: any[] = [];
  pdfdata: any;
  DocName = '';
  displayDialog = false;
  proposalId!: number | string;
  proposalName = '';
  schemeId!: number | string;
  phaseId!: number | string;
  step_details: any;
  userGuide: string = 'process';
  reportList: any[] = [];
  documentList: any[] = [];
  searchText = '';
  tabList: any[] = [];
  confirmChecked = false;
  private subscriptions = new Subscription();

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    const paramsSub = this.route.queryParams.subscribe(params => {
      this.proposalId = params['id'];
      this.proposalName = params['name'] ?? '';
      this.phaseId = params['phase'];
      this.schemeId = params['scheme'];
    });
    this.subscriptions.add(paramsSub);
    this.fetchMasterData();
    this.fetchTabs();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  getDocumentList(): void {
    if (!this.proposalId) return;
    this.documentList = [];
    const sub = this.api
      .getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.documentList = res?.data || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch documents.'
        })
      });
    this.subscriptions.add(sub);
  }


  comment: string = '';
  submitIRA(): void {
    if (!this.step_details?.id) return;
    const payload = {
      editor_turn: this.step_details.editor_id,
      remarks: this.comment,
    };
    const sub = this.api.postAPI(`/file_mange/editor/approve/`, payload).subscribe(res => {
      if (res.status !== 'Approved') {

        this.transHeaderSteperComponent?.navigate(1, true);
      } else {
        this.transHeaderSteperComponent?.navigate(1, false, true);
      }
    }
    );
    this.subscriptions.add(sub);
  }



  private fetchMasterData(): void {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.masterData = data.map((item: any) => ({
          id: item.id,
          name: item.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2)
        }));
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch master data.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchTabs(): void {
    if (!this.schemeId) return;
    const sub = this.api.getAPI(`/master/scheme/${this.schemeId}/phases/`).subscribe({
      next: (res: any) => (this.tabList = res || []),
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch phases.'
      })
    });
    this.subscriptions.add(sub);
  }

  showConfirm(): void {
    this.messageService.clear('confirm');
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Are you sure you want to submit this proposal?'
    });
  }
  topRender = true;
  submitProposal(action: 1 | 2): void {
    if (this.needGen) {
      this.needGen.onSubmit();
    }
    if (this.sotr) {
      this.sotr.onSubmit();
    }
    if (this.aip) {
      this.aip.onSubmit();
    }
    if (this.idexRfpSoc) {
      this.idexRfpSoc.onSubmit(1);
    }
    if (this.aon) {
      this.aon.onSubmit();
    }
    if (this.constituteCommittee) {
      this.constituteCommittee.onSubmit();
    }
    if (this.preRfpMeeting) {
      this.preRfpMeeting.onSubmit();
    }
    if (this.idexCommercialRfp) {
      this.idexCommercialRfp.onRFPSubmit();
    }
    if (this.preBid) {
      this.preBid.onSubmit();
    }
    if (this.banchmark) {
      this.banchmark.submitProposalData();
    }
    if (this.commercialEvaluation) {
      this.commercialEvaluation.onSubmit();
    }
    if (this.finalOffer) {
      this.finalOffer.onSubmit();
    }
    if (this.sanctionOrder) {
      this.sanctionOrder.onSubmit();
    }
    if (this.nominateDirectorate) {
      this.nominateDirectorate.onSubmit();
    }
    if (this.uploadDrawings) {
      this.uploadDrawings.onSubmit();
    }
    if (this.uploadQapAtp) {
      this.uploadQapAtp.onSubmit();
    }
    if (this.uploadFats) {
      this.uploadFats.onSubmit();
    }
    if (this.idexPrototype) {
      this.idexPrototype.onSubmit();
    }
    if (this.idexUtrr) {
      this.idexUtrr.onJustificationSubmit();
    }
    if (this.userCertificate) {
      this.userCertificate.onSubmit();
    }
    if (this.bulkProduction) {
      this.bulkProduction.onSubmit();
    }
    if (this.projectClosure) {
      this.projectClosure.onSubmit();
    }
    if (this.uploadHatSatComponent) {
      this.uploadHatSatComponent.onSubmit();
    }
    if (this.revenueBidComponent) {
      this.revenueBidComponent.saveTenderSheet();
    }
    if (this.sotrRfpComplienceMatrix) {
      this.sotrRfpComplienceMatrix.onSubmit();
    }
    if(this.firmCapacityAssessment){
      this.firmCapacityAssessment.onSubmit();
    }

    this.messageService.clear('confirm');
    if (action === 2) {
      this.submitIRA();

    }
  }

  apiResponse: any;
  getReportData(): void {
    this.api.getAPI(`/revenue/proposal/report/${this.proposalId}/`).subscribe((res) => {
      this.apiResponse = res;
    });
  }


  checkIsNextRouteConfig() {
    const t = this.api.getData() || [];


    // current working directorate (top level)
    const currentIndex = t.findIndex(s => (s?.status ?? "") === "working");
    if (currentIndex === -1) return false;

    // 1) current directorate ke internalUsers me (current working user ke baad) koi edit hai kya?
    const curr = t[currentIndex];
    if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
      const internalIndex = curr.internalUsers.findIndex(u => (u?.status ?? "") === "working");

      if (internalIndex !== -1) {
        const hasNextInternalEdit = curr.internalUsers
          .slice(internalIndex + 1)
          .some(u => (u?.permission ?? "") === "edit");

        if (hasNextInternalEdit) return true;
      } else {
        // Agar koi internal "working" marked hi nahi hai, still check any internal edit
        if (curr.internalUsers.some(u => (u?.permission ?? "") === "edit")) return true;
      }
    }

    // 2) currentIndex ke baad ke sabhi next directorates + unke internalUsers me koi edit hai kya?
    for (let i = currentIndex + 1; i < t.length; i++) {
      const next = t[i];

      // next directorate itself has edit
      if ((next?.permission ?? "") === "edit") return true;

      // next directorate ke kisi bhi internal user ke paas edit
      if (next?.hasInternal && Array.isArray(next.internalUsers) && next.internalUsers.length) {
        const anyInternalEdit = next.internalUsers.some(u => (u?.permission ?? "") === "edit");
        if (anyInternalEdit) return true;
      }
    }

    return false;
  }

  trigarFromChild(): void {
    this.messageService.clear('confirm');
    this.transHeaderSteperComponent?.openDialog();
    this.transHeaderSteperComponent?.giveTheRouteconfigAccess();
  }
  currentStepChange(event: any): void {
    this.step_details = event;
  }

}
